<section class="pt-2">
  <div class="container-style">
    <div class="row align-items-center mx-0 p-1">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6>{{isFormView ? 'Editar detalle de pedido' : 'Detalle de pedido'}}</h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
        <app-custom-button [disabled]="disablePartial" [label]="'Nuevo Detalle'" [severity]="'success'" [width]="'6'"
          (onClick)="openArticleSelectionModal()">
        </app-custom-button>
        <app-custom-modal #articleForOrderSelection [inputs$]="inputsForArticlesSelection$" [width]="'80vw'"
          [children]="componentTableSelection" [output$]="output$" [label]="'Seleccionar'"
          [header]="'Selección de Artículos'" hidden (selectedItems)="handleSelectedItem($event)">
        </app-custom-modal>
      </div>
    </div>
    <div class="row mx-0" [hidden]="!isFormView">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-register-order-adjustment-detail [orderAdjustmentDetails]="orderAdjustmentDetails"
          [orderContract]="orderAdjustmentModel" [costCenterPriceContract]="costCenterPriceContract"
          [orderDetailContract]="orderAdjustmentDetail" (isFormView)="isFormView = $event"
          (updateListDetail)="getOrderDetailsForCaptureTable()"
          (costCenterPriceRegister)="getCostCenterPriceOpen($event)"
          (openOrderPriceModal)="handleCostCenterPriceModal($event)">
        </app-register-order-adjustment-detail>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" [actions]="tableActions" [showCheckbox]="!disablePartial"
        (onAction)="onAction($event)" (onRecoverData)="getOrderDetailsForCaptureTable()"
        (onPageChange)="onPageChange($event)">
      </app-custom-table>
    </div>
  </div>
</section>
<!-- Precios Pedido -->
<app-custom-modal #orderPriceModal [inputs$]="inputsForPriceOrderModals$" hidden [header]="'Precios por pedido'"
  [width]="'50rem'" [label]="'Precios por pedido'" [children]="componentOrderPriceModal" (params)="reload($event)">
</app-custom-modal>
<!-- Precios C.Costos -->
<app-custom-modal #costCenterPriceRegisterModal [label]="'Precios C.Costos - Captura'"
  [header]="'Precios C.Costos - Captura'" [inputs$]="inputsForRegisterModals$" [width]="'50rem'"
  [children]="componentRegisterModal" hidden (params)="getCostCenterPriceRegister($event.costCenterPriceModel)">
</app-custom-modal>